<template>
  <div class="DarkWhite pa-4">
      <h2 class="subheading green--text mb-4">Inventory Scanning</h2>
      <QRScanning/>
  </div>
</template>

<script>
import QRScanning from '../components/Supply/QRScanning.vue'
  export default {
    components: {
      QRScanning
    },
    data: () => ({
    }),
  }
</script>

<style scoped>
</style>